import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { canViewRoomRevenueKpiBasis, isModuleEnabled } from './utils/permissions';
import FinancePage from './pages/FinancePage';
import { financeRoutes } from './routes';

export const financeModule = {
  key: 'finance',
  label: 'Finance',
  description: 'Dashboard, report e configurazioni finanziarie.',
  icon: AccountBalanceIcon,
  accent: 'primary',
  workspacePath: '/finance',
  settingsPath: '/settings',
  routes: financeRoutes,
  isAvailable: (user) => canViewRoomRevenueKpiBasis(user) && isModuleEnabled(user, 'finance'),
  settingsSections: [
    {
      key: 'finance-kpi',
      label: 'Finance',
      component: FinancePage,
    },
  ],
};